import {inject, Injectable} from '@angular/core';
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";

@Injectable({
    providedIn: 'root'
})
export class ModalService {
    private ngbModal = inject(NgbModal);

    constructor() {
    }

    public show(componentName: any, data?: object, size: 'sm' | 'lg' | 'xl' | 'md' = 'lg', centered: boolean = false, className?: string) {
        let appContainer: any = document.getElementById('app-container');
        if (!componentName) {
            throw new Error('Component is required to show modal.');
        }
        const modal: NgbModalRef = this.ngbModal.open(componentName, {
            size: size,
            windowClass: className ? className : '',
            container: appContainer,
            centered: centered
        });
        if (data && Object.keys(data).length && modal.componentInstance) {
            modal.componentInstance.config = {...modal.componentInstance.config, ...data};
        }
        return modal;
    }
}
